import type { CheckoutNetwork } from '../api/checkout';

const LABELS: Record<CheckoutNetwork, string> = {
  ETHEREUM: 'Ethereum',
  BASE: 'Base',
  ARBITRUM: 'Arbitrum One',
  OPTIMISM: 'Optimism',
  POLYGON: 'Polygon',
  SOLANA: 'Solana',
  BITCOIN: 'Bitcoin',
  TRON: 'Tron',
};

export function networkDisplayName(network: CheckoutNetwork): string {
  return LABELS[network] ?? network;
}

/**
 * Display names for the provider's chain keys, which are lower-case slugs
 * (`eth`, `sol`, `arb`) and are NOT the `CheckoutNetwork` union. Unmapped keys
 * fall back to the upper-cased slug so an unfamiliar chain still reads as a
 * chain rather than as a bug.
 */
const ORIGIN_CHAIN_LABELS: Record<string, string> = {
  eth: 'Ethereum',
  ethereum: 'Ethereum',
  base: 'Base',
  arb: 'Arbitrum One',
  arbitrum: 'Arbitrum One',
  op: 'Optimism',
  optimism: 'Optimism',
  polygon: 'Polygon',
  pol: 'Polygon',
  bsc: 'BNB Chain',
  bnb: 'BNB Chain',
  avax: 'Avalanche',
  avalanche: 'Avalanche',
  gnosis: 'Gnosis',
  linea: 'Linea',
  scroll: 'Scroll',
  zksync: 'zkSync',
  blast: 'Blast',
  mantle: 'Mantle',
  berachain: 'Berachain',
  sol: 'Solana',
  solana: 'Solana',
  btc: 'Bitcoin',
  bitcoin: 'Bitcoin',
  tron: 'Tron',
  trx: 'Tron',
  ton: 'TON',
  stellar: 'Stellar',
  xlm: 'Stellar',
  near: 'NEAR',
  doge: 'Dogecoin',
  xrp: 'XRP Ledger',
  sui: 'Sui',
  apt: 'Aptos',
  aptos: 'Aptos',
  cardano: 'Cardano',
  ada: 'Cardano',
};

export function originBlockchainLabel(blockchain: string): string {
  const key = blockchain.trim().toLowerCase();
  return ORIGIN_CHAIN_LABELS[key] ?? key.toUpperCase();
}
